import * as url from "../url.helper";

import { post } from "../api.helper";

export const addSystemConfiguration = data => post(url.ADD_SYSTEM_CONFIGURATION, data);

export const getSystemConfiguration = (data) => post(url.GET_SYSTEM_CONFIGURATION, data);

export const editSystemConfiguration = data => post(url.EDIT_SYSTEM_CONFIGURATION, data);

export const getOneSystemConfiguration = data => post(url.ONE_SYSTEM_CONFIGURATION, data);

export const getSystemConfigurationById = data => post(url.GET_ONE_SYSTEM_CONFIGURATION, data);

export const uploadFile= data => {
    const formData = new FormData()
    formData.append("upl",data)
    return post(url.UPLOAD_FILE,formData,{headers:{
    'Content-Type':'multipart/form-data'
}})};

export const downloadSystemConfigFile = data => post(url.DOWNLOAD_FILE, data);

export const downloadFile = (base64String, ext, fileName) => {
    let source = "";
    if (ext == "zip") {
        source = `data:application/zip;base64,${base64String}`;
        const link = document.createElement("a");
        link.href = source;
        link.download = fileName;
        link.click();
    } else {
        source = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${base64String}`;
        const link = document.createElement("a");
        link.href = source;
        link.download = fileName;
        link.click();
    }
}